import { useProductsStore } from '@/store/products';
import { useTrackingPage } from "./all-pages";

export const useTrackingDP = () => {
  const { $partenairesEvents } = useNuxtApp();

  const { query, params } = useRoute();

  const productsStore = useProductsStore();

  const { contentType, breadcrumbs, title, productsCount } = storeToRefs(productsStore)

  const { trackPage } = useTrackingPage();

  const pageType = computed(() => {
    switch (contentType.value) {
      case universePageCodes.UNIVERS:
        return trackingCodes.PAGETYPE.univers;
      case universePageCodes.MARQUE_LISTING:
        return trackingCodes.PAGETYPE.listingMarques;
      case universePageCodes.MARQUE_LANDING:
        return trackingCodes.PAGETYPE.pageMarque;
      default:
        return trackingCodes.PAGETYPE.category;
    }
  });

  const trackDP = () => {
    trackPage(
      pageType.value,
      breadcrumbs.value && breadcrumbs.value[0]
        ? breadcrumbs.value[0].title
        : title.value,
      breadcrumbs.value && breadcrumbs.value[1] ? breadcrumbs.value[1].title : "",
      contentType.value !== universePageCodes.UNIVERS &&
        breadcrumbs.value &&
        breadcrumbs.value[2]
        ? breadcrumbs.value[2].title
        : "",
      contentType.value !== universePageCodes.UNIVERS &&
        breadcrumbs.value &&
        breadcrumbs.value[3]
        ? breadcrumbs.value[3].title
        : ""
    );
  }

  const emitEventPartenaires = () => {
    if (process.client) {
      if (
        typeof window.cora.partenaires.router.onProductsListLoaded !== "undefined"
      ) {
        $partenairesEvents.dispatch(
          "products-list-loaded",
          {
            context: "liste-produits",
            page: query.pageindex ? query.pageindex : "1",
            perPage: productsCount.value,
            sort: params.filtersQuery
          },
          true
        );
      }
    }
  }

  return { trackDP, emitEventPartenaires }
}
